import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import { Card, Col, Button, Form } from "react-bootstrap";
import Toast from "~/components/Toast";
import logo from "~/assets/img/logos/unik-logo.png";
import "~/pages/Register/styles.css";

import {
  validateAdminReset,
} from "~/store/ducks/resetPassword/actionTypes";

const ConfirmResetAdminPassword = ({ t }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { isLoadingValidateAdminReset, successValidateAdminReset } =
    useSelector((state) => state.resetPasswordReducer);

  const [validated, setValidated] = useState(false);
  const [rawCode, setRawCode] = useState("");
  const [code, setCode] = useState("");

  useEffect(() => {
    if (rawCode.length === 5) {
      digestMessage(rawCode).then((digestHex) => setCode(digestHex));
    } else {
      setCode("");
    }
  }, [rawCode]);

  useEffect(() => {
    if (successValidateAdminReset) {
      backToLogin();
    }
  }, [successValidateAdminReset]);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      dispatch(validateAdminReset(code));
    }
  };
 
  const backToLogin = () => {
    const payload = {
      pathname: `/`,
      state: { name: "Login" },
    };
    history.replace(payload);
  };

  async function digestMessage(message) {
    const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // code the message
    const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // convert bytes to hex string
    return hashHex;
  }

  return (
    <div className={"register-form-wrapper register-center"}>
      <div className="overlay">
        <div className="row">
          <div className="col-12 mt-3 mb-2 text-center">
            <a href="/#">
              <img
                className="img-fluid unik-logo"
                src={logo}
                alt="Uniksystem"
              />
            </a>
          </div>
        </div>
        <div
          style={{ maxHeight: "320px" }}
          className="col-xl-5 col-lg-8 col-md-10  my-2 register-form"
        >
          <Card style={{ border: "0px", borderRadius: "23px", width: "100%" }}>
            <Form
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
              noValidate
              validated={validated}
              onSubmit={handleSubmit}
              method="post"
              encType="multipart/form-data"
            >
              <Card.Header className="register-header">
                <span className="label-register">
                  {t("resetAdminPassword.confirmEmail.header")}
                </span>
              </Card.Header>

              <Card.Body className="register-body">
                <span className="reg-confirmation-txt">
                  {t("resetAdminPassword.confirmEmail.body")}
                </span>
                <Form.Row style={{ paddingTop: "15px" }}>
                  <Col sm="12" md="12" lg="12">
                    <Form.Group controlId="validationValidateCodeAdmin">
                      <Form.Label className="register-form-label">
                        {t("resetAdminPassword.confirmEmail.code")}
                      </Form.Label>
                      <Form.Control
                        type="text"
                        autofill="false"
                        required
                        autoComplete="off"
                        style={{ textAlign: "center" }}
                        value={rawCode}
                        onChange={(e) => setRawCode(e.target.value.trim())}
                      />
                      <Form.Control.Feedback type="invalid">
                        {t("resetAdminPassword.confirmEmail.requiredCode")}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Form.Row>
              </Card.Body>
              <Card.Footer className="register-confirm-footer">
                <Button
                  className="card-button"
                  type="submit"
                  style={{
                    backgroundColor: "#33058d",
                    borderColor: "#33058d",
                    height:"44px",
                    borderRadius:"23px"
                  }}
                >
                  {isLoadingValidateAdminReset
                    ? t("login.loading")
                    : t("resetAdminPassword.confirmEmail.confirm")}
                </Button>
              </Card.Footer>
            </Form>
          </Card>
        </div>
        <Toast /> 
      </div>
    </div>
  );
};

export default withNamespaces()(ConfirmResetAdminPassword);
